module.exports = __webpack_public_path__ + "media/images/header_logo-07f7b9b86237e3d6b1de88b6d5efcd07.png";